'use client'

import { useEffect, useState } from 'react'
import { useRouter, usePathname } from 'next/navigation'
import { supabase } from '@/lib/supabase'

/**
 * 試用版 Layout
 * 不需要登入和權益檢查，但保持基本安全保護
 */
export default function TryLayout({ children }: { children: React.ReactNode }) {
  const router = useRouter()
  const pathname = usePathname()
  const [hasEntitlement, setHasEntitlement] = useState<boolean | null>(null)

  useEffect(() => {
    const checkEntitlement = async () => {
      try {
        // 先檢查用戶是否登入，未登入直接返回，不調用 API
        const { data: { user }, error: authError } = await supabase.auth.getUser()
        
        // 如果沒有用戶或認證錯誤，直接設置為 false，不調用 API
        if (authError || !user) {
          setHasEntitlement(false)
          return
        }

        // 只有確認用戶已登入後，才調用 API 檢查訂閱權限
        const res = await fetch('/api/me/entitlement', { 
          cache: 'no-store',
          credentials: 'include'
        })
        
        if (res.ok) {
          const data = await res.json()
          const entitlement = data.entitlement
          const now = Date.now()
          const hasValidSubscription = entitlement?.endAt && new Date(entitlement.endAt).getTime() > now
          setHasEntitlement(hasValidSubscription && entitlement.tier !== 'None')
        } else {
          // API 返回非 200 狀態，設置為 false
          setHasEntitlement(false)
        }
      } catch (error) {
        // 任何錯誤都設置為 false，不調用 API
        setHasEntitlement(false)
      }
    }

    checkEntitlement()
  }, [])

  const handleLogoClick = () => {
    if (hasEntitlement) {
      // 有訂閱權限 → 導向 dashboard
      router.push('/dashboard')
    } else {
      // 無訂閱權限或未登入 → 導向首頁
      router.push('/')
    }
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Try 頁面專用 Header */}
      <header className="bg-gray-900 border-b border-gray-800">
        <nav className="container mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <button
              onClick={handleLogoClick}
              className="text-xl font-bold text-white hover:text-gray-300 transition-colors"
            >
              JLPT AI Tutor
            </button>
          </div>
        </nav>
      </header>
      {children}
    </div>
  )
}

